import { Dispatch, SetStateAction, useState } from "react";
import { Toaster } from "react-hot-toast";
import { toastError } from "../../../../components/Toast";
import BackCards from "./components/BackCards";
import Button from "./components/Button";
import InputData from "./components/InputData";

interface IFilterRowProps {
  dateTo?: string;
  dateFrom?: string;
  filterType?: "date" | "any";
  multipleCard?: boolean;
  setMultipleCard?: Dispatch<SetStateAction<{ userId: number; status: boolean }>>;
  setDateTo?: Dispatch<SetStateAction<string>>;
  setDateFrom?: Dispatch<SetStateAction<string>>;
  getListDetails?: (p?: string) => void;
}

export default function FilterRow({
  multipleCard,
  filterType = "any",
  dateTo,
  dateFrom,
  setMultipleCard,
  getListDetails,
  setDateTo,
  setDateFrom,
}: IFilterRowProps): JSX.Element {
  function handleFilterDateClick() {
    if (filterType !== "date") return;
    if (!dateFrom) return toastError("Data inicial obrigatória!");
    if (!dateTo) return toastError("Data final obrigatória!");
    getListDetails(`&dateFrom=${dateFrom}&dateTo=${dateTo}`);
  }

  function handelClearFilterClick() {
    setDateFrom("");
    setDateTo("");
    getListDetails();
  }

  return (
    <>
      <Toaster />
      <div className="header-filter-menu rowFilterContainer between">
        <div className="flex">
          <InputData dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} />
          <Button handleFilterClick={handleFilterDateClick} handelClearFilterClick={handelClearFilterClick} />
        </div>
        {multipleCard && <BackCards setMultipleCard={setMultipleCard} />}
      </div>
    </>
  );
}
